
        var result = require("!!../../../../node_modules/css-loader/index.js!./shared.bookmarked.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/tenders/shared.bookmarked.component.css
// module id = 650
// module chunks = 0